import React from 'react';

const Calendar: React.FC = () => (
    <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx={20} cy={20} r={20} fill="#EEEDF2" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5 8a.5.5 0 0 1 .5.5V9h8v-.5a.5.5 0 0 1 1 0V9h3.5a.5.5 0 0 1 .5.5v22a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-22a.5.5 0 0 1 .5-.5H15v-.5a.5.5 0 0 1 .5-.5Zm-.5 2h-3v4h2.5a.5.5 0 0 1 0 1H12v16h16V15H17.5a.5.5 0 0 1 0-1H28v-4h-3v.5a.5.5 0 0 1-1 0V10h-8v.5a.5.5 0 1 1-1 0V10Zm.5 9a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm4-7a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm5-8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
            fill="#535163"
        />
    </svg>
);

export default Calendar;
